import { api } from "./api";

export async function fetchCatalogo(pilar) {
  // Pilares 02 (Software) y 03 (Academia) usan catálogos gestionables reales en BD.
  const map = { software: "/software/catalogo", academia: "/academia/catalogo" };
  const url = map[pilar] || `/catalogo/${pilar}`;
  const { data } = await api.get(url);
  return data; // { pilar, plan, descuento_pct, items[] }
}
